module.exports = "fragment Banner on ClubBanner {\n  institutional\n  partner { slug , is_exclusive}\n  campaign { slug }\n  link\n  type\n  name\n  image\n  tags\n  showcase\n  id\n  vidalink\n  only_tagged\n}\n\nquery Banners ($result: Boolean = false, $tag: String) {\n  bannerResult: banners (\n    tag: $tag\n    type: \"1\"\n  ) @include (if: $result) {\n    ... Banner\n    id\n  }\n\n  banners (\n    tag: $tag\n    type: \"0\"\n  ) @skip (if: $result) {\n    ... Banner\n    image_secondary\n   }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Banners.graphql
// module id = 1859
// module chunks = 1612